import { z } from 'zod';

export const CustomerSearchFiltersSchema = z.object({
  search: z.string().nullish().catch(null),
  page: z.number().min(1).default(1).catch(1),
  pageSize: z.number().min(1).max(100).default(20).catch(20),
  showFavoritesOnly: z.boolean().nullish().catch(null),
});

export const systemCustomerAssignmentSchema = z.object({
  customerId: z.string().min(1, 'Customer selection is required'),
});

export const customerSchema = z.object({
  customerId: z.string(),
  accountName: z.string(),
  address1: z.string().nullish(),
  address2: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  zipCode: z.string().nullish(),
  country: z.string().nullish(),
  hold: z.boolean().nullish(),
  region: z.string().nullish(),
  isFavorite: z.boolean().default(false),
  createdAt: z.string(),
  updatedAt: z.string().nullish(),
  lastUpdatedAt: z.string(),
});

export enum SystemCustomerAssociationSource {
  Manual = 0,
  License = 1,
}

export const systemCustomerAssociationDtoSchema = z.object({
  customer: customerSchema,
  source: z.nativeEnum(SystemCustomerAssociationSource),
});

export const getSystemCustomerAssociationsResponseSchema = z.object({
  systemCustomerAssociationDtos: z.array(systemCustomerAssociationDtoSchema),
});

export enum CustomerSystemSortOrder {
  MachineNameAsc = 0,
  MachineNameDesc = 1,
  RegisteredAtAsc = 2,
  RegisteredAtDesc = 3,
  LastCheckedAtAsc = 4,
  LastCheckedAtDesc = 5,
  IsOnlineAsc = 6,
  IsOnlineDesc = 7,
}

export const customerSystemSortOrderSchema = z.nativeEnum(CustomerSystemSortOrder);

export const customerSystemDtoSchema = z.object({
  systemId: z.string(),
  customerId: z.string(),
  systemMachineName: z.string().nullish(),
  licenseIds: z.array(z.string()),
  products: z.array(z.string()),
  isOnline: z.boolean(),
  lastCheckedAt: z.string().nullish(),
  registeredAt: z.string(),
});

export const getCustomerSystemsResponseSchema = z.object({
  customerSystems: z.array(customerSystemDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
});

export const assignSystemToCustomerResponseSchema = z.object({
  systemId: z.string(),
  customerId: z.string(),
  success: z.boolean(),
  assignedAt: z.string().nullish(),
  failureReason: z.string().nullish(),
});

export const assignSystemToCustomerResponsesSchema = z.array(assignSystemToCustomerResponseSchema);

export const listCustomersResponseSchema = z.object({
  customers: z.array(customerSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
});

export const cadwellApplicationDtoSchema = z.object({
  applicationName: z.string(),
  installDate: z.string().nullish(),
  isCurrentlyInstalled: z.boolean(),
  version: z.string(),
});

export const systemEnvironmentAndApplicationsDtoSchema = z.object({
  systemId: z.string(),
  machineName: z.string(),
  currentTimeZone: z.number(),
  daylightSavingsInEffect: z.boolean(),
  domain: z.string(),
  locale: z.string(),
  applications: z.array(cadwellApplicationDtoSchema),
});

export const unassignedSystemLicenseInfoSchema = z.object({
  systemId: z.string(),
  licenseCount: z.number(),
  systemEnvironmentAndApplications: systemEnvironmentAndApplicationsDtoSchema,
  trialEndedAt: z.string().nullish(),
});

export const listUnassignedSystemsResponseSchema = z.object({
  systems: z.array(unassignedSystemLicenseInfoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
